(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/fractiongames/assets/react/components/game-card/buyin-info.js') >= 0) return;  svs.modules.push('/components/numbergames/fractiongames/assets/react/components/game-card/buyin-info.js');

'use strict';

const {
  useContext,
  useEffect,
  useState
} = React;
const {
  useSelector
} = ReactRedux;
const {
  getWeekdayAndTime
} = svs.utils.date;
const {
  clientNow
} = svs.numbergames.draws.drawsApi;
const {
  Countdown
} = svs.numbergames.fractiongames.components.gamecard;
const {
  ContainerContext
} = svs.numbergames.fractiongames.contexts;
const MS_IN_MINUTE = 60 * 1000;
const initShowCountdown = buyinCloseTime => {
  if (!buyinCloseTime) return false;
  const millisecondsDiff = dateFns.differenceInMilliseconds(new Date(buyinCloseTime), clientNow());
  const minutesLeft = Math.ceil(millisecondsDiff / MS_IN_MINUTE);
  return minutesLeft > 0 && minutesLeft < 60;
};
const BuyInInfo = () => {
  const {
    selectors
  } = useContext(ContainerContext);
  const isOpen = useSelector(selectors.selectIsOpen);
  const buyinCloseTime = useSelector(selectors.selectBuyinCloseTime);
  const [showCountdown, setShowCountdown] = useState(initShowCountdown(buyinCloseTime));
  useEffect(() => {
    if (!isOpen) {
      setShowCountdown(false);
    } else if (!showCountdown) {
      const buyinCloseDate = new Date(buyinCloseTime);
      if (!dateFns.differenceInDays(buyinCloseDate, clientNow())) {
        const timeout = setTimeout(() => {
          setShowCountdown(true);
        }, dateFns.differenceInMilliseconds(buyinCloseDate, clientNow()) - 59 * MS_IN_MINUTE);
        return () => clearTimeout(timeout);
      }
    }
  }, [buyinCloseTime, isOpen, showCountdown]);
  if (isOpen && showCountdown) {
    return React.createElement(Countdown, null);
  }
  if (isOpen) {
    return "K\xF6pstopp: ".concat(getWeekdayAndTime(buyinCloseTime));
  }
  return 'Köpstopp';
};
svs.numbergames.fractiongames.components.gamecard.BuyInInfo = BuyInInfo;

 })(window);